import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import TopBar from './TopBar';
import manualTopUpService from '../services/manualTopUpService';
import qrCode from './CondoEats Temp QR.jpeg';
import './ManualTopUpPage.css';

const PACKAGES = [
    { id: '15', label: 'RM 15', amount: 15 },
    { id: '25', label: 'RM 25', amount: 25 },
    { id: '50', label: 'RM 50', amount: 50 }
];

const ManualTopUpPage = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { showSuccess, showError } = useToast();

    const [selectedAmount, setSelectedAmount] = useState(PACKAGES[0].id);
    const [receipt, setReceipt] = useState(null);
    const [receiptPreview, setReceiptPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                showError('File is too large. Max 5MB allowed.');
                return;
            }
            setReceipt(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setReceiptPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!user) {
            showError('Please login to continue');
            return;
        }
        if (!receipt) {
            showError('Please upload a bank-in receipt');
            return;
        }

        setLoading(true);
        try {
            // 1. Upload receipt
            const receiptId = await manualTopUpService.uploadReceipt(receipt);

            // 2. Create top-up request
            await manualTopUpService.createManualTopUpRequest({
                amount: selectedAmount,
                receiptId: receiptId
            }, user.$id);

            showSuccess('Top-up request submitted successfully! Please wait for admin approval.');
            navigate('/topup');
        } catch (error) {
            console.error('Manual top up error:', error);
            showError(error, 'Failed to submit top-up request. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="manual-topup-page">
            <TopBar />
            <div className="manual-topup-container">
                <div className="manual-topup-content">
                    <div className="manual-topup-heading">
                        <h1>Manual Top-Up</h1>
                        <p>Select your package and upload your bank-in receipt</p>
                    </div>

                    <div className="manual-topup-section">
                        <div className="section-header">
                            <h2>Select Amount</h2>
                        </div>
                        <div className="package-grid">
                            {PACKAGES.map((pkg) => (
                                <div
                                    key={pkg.id}
                                    className={`package-card ${selectedAmount === pkg.id ? 'selected' : ''}`}
                                    onClick={() => setSelectedAmount(pkg.id)}
                                >
                                    <div className="package-amount">RM {pkg.amount.toFixed(2)}</div>
                                    {selectedAmount === pkg.id && <div className="selected-badge">✓</div>}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="manual-topup-section">
                        <div className="section-header">
                            <h2>Upload Receipt</h2>
                        </div>

                        <div className="bank-details-card">
                            <h3>Bank Transfer Details</h3>
                            <div className="bank-info-line">
                                <span>Bank Name:</span>
                                <strong>Maybank</strong>
                            </div>
                            <div className="bank-info-line">
                                <span>Account Number:</span>
                                <strong>562366784410</strong>
                            </div>
                            <div className="bank-info-line">
                                <span>Account Holder:</span>
                                <strong>TAY CHEAN HAO</strong>
                            </div>
                        </div>

                        <div className="qr-section">
                            <h3>Scan to Pay</h3>
                            <div className="qr-container">
                                <img src={qrCode} alt="CondoEats QR Code" className="bank-qr-code" />
                            </div>
                        </div>

                        <div className="upload-container">
                            <input
                                type="file"
                                id="receipt-upload"
                                className="hidden-input"
                                onChange={handleFileChange}
                                accept="image/*"
                            />
                            <label htmlFor="receipt-upload" className="upload-label">
                                {receiptPreview ? (
                                    <div className="preview-container">
                                        <img src={receiptPreview} alt="Receipt Preview" className="receipt-preview" />
                                        <div className="change-photo-overlay">Change Photo</div>
                                    </div>
                                ) : (
                                    <div className="upload-placeholder">
                                        <span className="upload-icon">📷</span>
                                        <span>Click to upload receipt photo</span>
                                        <span className="upload-subs">Maximum file size: 5MB</span>
                                    </div>
                                )}
                            </label>
                        </div>
                    </div>

                    <div className="manual-topup-footer">
                        <p className="notice-text">
                            Automated top-up is coming very soon. We apologize for the temporary inconvenience.
                        </p>
                        <button
                            className="submit-btn"
                            onClick={handleSubmit}
                            disabled={loading || !receipt}
                        >
                            {loading ? 'Submitting...' : 'Submit Request'}
                        </button>
                        <button className="back-btn" onClick={() => navigate('/topup')}>
                            Back to Packages
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManualTopUpPage;
